export default __webpack_public_path__ + "static/media/userPreview.7b73d924.svg";